import { render, staticRenderFns } from "./OtherUserInfo.vue?vue&type=template&id=1c0a7b2d&scoped=true&"
import script from "./OtherUserInfo.vue?vue&type=script&lang=js&"
export * from "./OtherUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./OtherUserInfo.vue?vue&type=style&index=0&id=1c0a7b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a7b2d",
  null
  
)

export default component.exports